import { render, staticRenderFns } from "./ConfigFractions.vue?vue&type=template&id=f83cde16"
import script from "./ConfigFractions.vue?vue&type=script&lang=js"
export * from "./ConfigFractions.vue?vue&type=script&lang=js"
import style0 from "./ConfigFractions.vue?vue&type=style&index=0&id=f83cde16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports